import * as React from 'react';
export const sevenelevenSvg = React.forwardRef(function sevenelevenSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.333 0A2.667 2.667 0 0 1 16 2.667v10.666A2.667 2.667 0 0 1 13.333 16H2.667A2.667 2.667 0 0 1 0 13.333V2.667A2.667 2.667 0 0 1 2.667 0h10.666ZM3.201 2a.547.547 0 0 0-.534.559l.879 10.216c0 .308.194.558.433.558h2.448V14H9.66v-.667l2.371-.001c.24 0 .434-.25.434-.558l.867-10.215A.546.546 0 0 0 12.801 2H3.2Zm8.611 4.143c-1.844.666-2.124 2.356-2.211 3.36-.068.85-.125 3.274-.125 4.317H6.607c0-1.052.04-2.26.348-4.713.242-1.96 1.41-4.26 4.857-5.717v2.753Zm-.89-2.626c-.652.244-2.637 1.587-3.133 2.49H4.306L4.3 3.518h6.622Z',
    }),
  );
});
sevenelevenSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var seveneleven = {
  category: 'paymentmethod',
  colorable: true,
  name: 'seveneleven',
  svg: sevenelevenSvg,
};
